import { match } from 'ts-pattern';
import type { useEnabledClaimType } from '~/hooks/useEnabledClaimType';
import { concierge } from './concierge/group';
import { orderEditing } from './orderEditing/group';
import { registrations } from './registrations/group';
import { returns } from './returns/group';
import { shippingProtection } from './shippingProtection/group';
import type { ReportGroup } from './types';
import { warranties } from './warranties/group';

export const reportGroups = [
  returns,
  warranties,
  shippingProtection,
  registrations,
  orderEditing,
  concierge,
] as const satisfies ReportGroup[];

// a refetch that fails keeps the config it had, and so its dashboards
export const offeredReportGroups = (
  enabled: ReturnType<typeof useEnabledClaimType>,
  isOrganization: boolean,
  isCorsoAdmin: boolean,
) => {
  const viewable = reportGroups.filter(
    (group: ReportGroup) => isCorsoAdmin || !group.isCorsoAdminOnly,
  );
  return (
    match({ hasLoaded: enabled.hasLoaded, isOrganization })
      // the organization's stores may sell what this one doesn't, so it is offered every dashboard
      .with({ isOrganization: true }, () => viewable)
      .with({ hasLoaded: true }, () =>
        viewable.filter(({ isEnabled }) => isEnabled(enabled)),
      )
      .otherwise(() => undefined)
  );
};
